export const moduleFamilyNames: Record<string, string> = {
  pp: "Power plants",
  t: "Thrusters",
  fsd: "Frame shift drives",
  ls: "Life support",
  pd: "Power distributors",
  s: "Sensors",
  ft: "Fuel tanks",
  sg: "Shield generators",
  psg: "Prismatic shield generators",
  sb: "Shield boosters",
  pwa: "Pulse wave analysers",
  cs: "Cargo scanners",
  sfn: "Field neutralisers",
  xs: "Xeno scanners",
  ws: "Frame shift wake scanners",
  kw: "Kill warrant scanners",
  hs: "Heat sink launchers",
  ch: "Chaff launchers",
  po: "Point defence",
  ec: "Electronic countermeasures",
  csl: "Caustic sink launchers",
  bl: "Beam lasers",
  ul: "Burst lasers",
  pl: "Pulse lasers",
  mc: "Multi-cannons",
  advmc: "Advanced multi-cannons",
  c: "Cannons",
  rg: "Rail guns",
  fc: "Fragment cannons",
  mr: "Missile racks",
  tp: "Torpedo pylons",
  axmr: "AX missile racks",
  axmre: "Enhanced AX missile racks",
  axmc: "AX multi-cannons",
  axmce: "Enhanced AX multi-cannons",
  ntp: "Guardian torpedo pylons",
  gfsb: "Guardian FSD boosters",
  ggc: "Guardian Gauss cannons",
  gpc: "Guardian plasma chargers",
  gsc: "Guardian shard cannons",
  ghrp: "Guardian hull reinforcement",
  gmrp: "Guardian module reinforcement",
  gsrp: "Guardian shield reinforcement",
  am: "Auto field-maintenance units",
  amr: "Advanced missile racks",
  bsg: "Bi-weave shield generators",
  cc: "Collector limpet controllers",
  cr: "Cargo racks",
  crl: "Mk II cargo racks",
  dc: "Docking computers",
  dtl: "Decontamination limpet controllers",
  ews: "Experimental weapon stabilisers",
  fh: "Vessel hangars",
  fi: "Frame shift drive interdictors",
  fs: "Fuel scoops",
  fx: "Fuel transfer limpet controllers",
  hb: "Hatch breaker limpet controllers",
  hr: "Hull reinforcement",
  mahr: "Mirrored armour",
  mlc: "Mining limpet controllers",
  mrp: "Module reinforcement",
  pas: "Planetary approach suites",
  pc: "Prospector limpet controllers",
  pce: "Economy passenger cabins",
  pci: "Business passenger cabins",
  pcm: "First-class passenger cabins",
  pcq: "Luxury passenger cabins",
  pv: "Planetary vehicle hangars",
  rcpl: "Recon limpet controllers",
  rf: "Refineries",
  rpl: "Repair limpet controllers",
  rsl: "Research limpet controllers",
  scb: "Shield cell banks",
  ss: "Detailed surface scanners",
  sua: "Supercruise assist",
  tbem: "Enzyme missile racks",
  rfl: "Flak launchers",
  tbrfl: "Flechette launchers",
  sdm: "Sub-surface missiles",
  nl: "Mine launchers",
  abl: "Abrasion blasters",
  scl: "Seismic charge launchers",
  ml: "Mining lasers",
  mvr: "Mining volley repeaters",
  pa: "Plasma accelerators",
  tbsc: "Shock cannons",
};
